import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconCheck = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...omit(props, ["className"])}
    ref={ref}
    className="yfm-icon yfm-icon-check"
  >
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="9"
      fill="#FF3700"
      stroke="#FF3700"
      strokeWidth="2"
    />
    <path
      d="M8.69891 13.9113C8.47753 13.9113 8.25703 13.8265 8.08816 13.6576L4.63278 10.1882C4.29591 9.84959 4.29591 9.30009 4.63278 8.96147C4.97053 8.62284 5.51741 8.62284 5.85428 8.96147L8.69891 11.8175L14.1344 6.36009C14.4713 6.02059 15.0182 6.02059 15.3559 6.36009C15.6928 6.69872 15.6928 7.24734 15.3559 7.58597L9.30966 13.6576C9.14078 13.8265 8.91941 13.9113 8.69891 13.9113Z"
      fill="white"
    />
  </svg>
));

IconCheck.displayName = "IconCheck";

export default IconCheck;
